import React, {useRef, useState} from 'react';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  TextInput,
  Button,
  Heading,
} from '@taopix/taopix-design-system';
import {useUiState} from '../Context/UserInterface/UserInterfaceContext';
import {useUserFlowState} from '../Context/UserFlow/UserFlowContext';
import {UserInterfaceActions} from '../Context/UserInterface/UserInterfaceActionTypes';
import {useTranslation} from 'react-i18next';
import {UserFlowStep} from '../../Facade/UserFlow/BaseUserFlow';
import {UserFlowType} from '../../Facade/UserFlow/UserFlowFacade';
import {KeyboardKeys} from '../../Enums';

export type ProjectNameDialogProps = {
  open: boolean;
};

const ProjectNameDialog = ({open, ...props}: ProjectNameDialogProps) => {
  const {t} = useTranslation(['*', 'dialogs']);
  const ui = useUiState();
  const userFlow = useUserFlowState();

  const [newProjectName, setNewProjectName] = useState<string>(ui.state.projectNaming.projectName);
  const textInputRef = useRef<any>();

  // add presing enter will submit dialog
  const onSave = () => {
    ui.dispatch(
      UserInterfaceActions.setProjectNameDialog({
        ...ui.state.projectNaming,
        previousProjectName: ui.state.projectNaming.projectName,
        projectName: newProjectName,
      })
    );
    userFlow.setNextStep();
  };

  const onClose = () => {
    userFlow.setCurrentStep(`${UserFlowType.Save}.${UserFlowStep.None}`);
  };

  return (
    <Dialog
      open={open}
      focusFirstElement
      trapFocus={true}
      width={400}
      theme={'tpx-theme-dialogs'}
      themeTip="Dialogs"
      id="project-name-dialog"
      title={t('dialogs:str_TitleProjectName', {defaultValue: 'Project Name'})}
      showTitle={false}
      aria-live="assertive"
      onClose={onClose}
    >
      <DialogContent>
        <div className={'space-y-sm'}>
          <Heading size={2}>{t('*:str_LabelProjectName')}</Heading>
          <TextInput
            id={'project-name-input'}
            name={'project-name-input'}
            ref={textInputRef}
            className={'w-full'}
            onChange={(event: any) => {
              setNewProjectName(event.target.value);
            }}
            defaultValue={ui.state.projectNaming.projectName}
            onKeyDown={e => {
              if (e.key === KeyboardKeys.ENTER) {
                onSave();
              }
            }}
          />
        </div>
      </DialogContent>
      <DialogFooter isSmallScreen={ui.state.isSmallScreen}>
        <Button label={t('*:str_ButtonClose')} buttonStyle={'secondary'} onClick={onClose} />
        <Button
          label={t('*:str_ButtonSave')}
          buttonStyle={'primary'}
          onClick={onSave}
          disabled={'' === textInputRef?.current?.value}
        />
      </DialogFooter>
    </Dialog>
  );
};

export default ProjectNameDialog;
